// src/components/FootyLadderPage.js
import React, { useState, useEffect } from "react";
import styles from "./FootyLadderPage.module.css";
import teamLogos from "../utils/teamLogos";
import TEAM_INFO from "../utils/teamInfo";

const FootyLadderPage = () => {
  const [ladder, setLadder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTeamAbbrev, setSelectedTeamAbbrev] = useState("");

  // map Squiggle team.id → our abbreviation (e.g. 1 → "ADEL")
  const idToAbbrev = Object.fromEntries(
    Object.entries(TEAM_INFO).map(([abbr, info]) => [info.id, abbr])
  );

  useEffect(() => {
    const saved = localStorage.getItem("selectedTeam");
    if (saved) setSelectedTeamAbbrev(saved);

    fetch("https://api.squiggle.com.au/?q=standings")
      .then((res) => res.json())
      .then(({ standings }) => {
        setLadder(standings);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className={styles.footyLadderPage}>
      <h1 className={styles.footyLadderTitle}>Footy Ladder</h1>
      <div className={styles.footyLadderContent}>
        {loading ? (
          <p className={styles.loadingText}>Loading…</p>
        ) : (
          <table className={styles.ladderTable}>
            <thead>
              <tr>
                <th>#</th>
                <th></th>
                <th>Team</th>
                <th>P</th>
                <th>W</th>
                <th>L</th>
                <th>D</th>
                <th>%</th>
                <th>Pts</th>
                <th>F</th>
                <th>A</th>
              </tr>
            </thead>
            <tbody>
              {ladder.map((team, idx) => {
                const abbrev = idToAbbrev[team.id];
                const isSelected = abbrev === selectedTeamAbbrev;
                const logoKey = TEAM_INFO[abbrev].logoKey;

                return (
                  <React.Fragment key={team.id}>
                    <tr className={isSelected ? styles.statsHighlightRow : ""}>
                      <td>{team.rank}</td>
                      <td className={styles.logoCell}>
                        <img
                          src={teamLogos[logoKey]}
                          alt={`${abbrev} logo`}
                          className={styles.teamLogo}
                        />
                      </td>
                      <td className={styles.teamNameCell}>
                        {isSelected ? (
                          <span className={styles.highlightedText}>
                            {abbrev}
                          </span>
                        ) : (
                          abbrev
                        )}
                      </td>
                      <td>{team.played}</td>
                      <td>{team.wins}</td>
                      <td>{team.losses}</td>
                      <td>{team.draws}</td>
                      <td>{team.percentage.toFixed(2)}</td>
                      <td>{team.pts}</td>
                      <td>{team.for}</td>
                      <td>{team.against}</td>
                    </tr>
                    {idx === 7 && (
                      <tr className={styles.topEightRow}>
                        <td colSpan="11" className={styles.topEightText}>
                          <span className={styles.topEightTextPadding}>
                            TOP 8
                          </span>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default FootyLadderPage;
